import { useSelector } from 'react-redux';
import {
  getIsValidAvailabilityRequest,
  getIsValidDirectSalesAvailabilityRequest,
} from 'store/dealManagement/selectors';
import { getIsDirectSalesCampaignType } from 'store/dealManagement/selectors/getCampaignType';

export const useEnableFeatureSelectionLayer = (): { isEnabled: boolean } => {
  const isValidDirectSalesAvailabilityRequest = useSelector(getIsValidDirectSalesAvailabilityRequest);
  const isValidAvailabilityRequest = useSelector(getIsValidAvailabilityRequest);
  const isDirectSalesCampaignType = useSelector(getIsDirectSalesCampaignType);

  return {
    isEnabled: (isDirectSalesCampaignType && isValidDirectSalesAvailabilityRequest) || isValidAvailabilityRequest,
  };
};
